import React from "react"
import clsx from "clsx"
import NumberSpinner from "../../NumberSpinner/NumberSpinner"

class BookingButtonBuilderSessionTimeout extends React.Component {

  constructor(props) {
    super(props);
  };

  render() {
    var tabClasses = clsx({
			'active': this.props.active_tab == 'session_timeout',
			'tab-pane': true,
		});

    return (
      <div className={tabClasses} id="session_timeout">
        <div className="row">
          <div className="form-group col-md-2">
            <label>{I18n.t('status')} <span className="ss-help help" title={I18n.t('session_timeout_helper_text')}></span></label> 
            <select name="session_timeout_enabled" value={this.props.session_timeout_enabled || 'disabled'} onChange={this.props.onChangeSessionTimeoutEnabled} className="form-control">
              <option value="enabled">{I18n.t('enabled')}</option>
              <option value="disabled">{I18n.t('disabled')}</option>
            </select>
          </div>
          <div className="form-group col-md-2">
            <label>{I18n.t('session_duration')} <span className="ss-help help" title={I18n.t('measured_in_seconds')}></span></label>
            <NumberSpinner
              id="session_timeout_duration"
              name="session_timeout_duration"
              value={this.props.session_timeout_duration || ''}
              onChange={this.props.onFieldChange}
              min={0}
              max={999}
            />
          </div>
          <div className="form-group col-md-2">
            <label>{I18n.t('session_grace_period')} <span className="ss-help help" title={I18n.t('measured_in_seconds')}></span></label>
            <NumberSpinner 
              id="session_grace_period"
              name="session_grace_period"
              value={this.props.session_grace_period || ''}
              onChange={this.props.onFieldChange}
              min={0}
              max={999}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <label>{I18n.t('session_timeout_warning_text')} <span className="ss-help help" title={I18n.t('session_timeout_warning_text_helper_text')}></span></label>
            <textarea className="form-control" rows={3} name="session_timeout_warning_text" id="session_timeout_warning_text" value={this.props.session_timeout_warning_text || ''} onChange={this.props.onFieldChange} />
          </div>
          <div className="col-md-6">
            <label>{I18n.t('session_timeout_confirmation_text')} <span className="ss-help help" title={I18n.t('session_timeout_confirmation_text_helper_text')}></span></label>
            <textarea className="form-control" rows={3} name="session_timeout_confirmation_text" id="session_timeout_confirmation_text" value={this.props.session_timeout_confirmation_text || ''} onChange={this.props.onFieldChange} />
          </div>          
        </div>
      </div>
    )
  }
}

export default BookingButtonBuilderSessionTimeout